import React, { Component } from 'react';
import moment from 'moment-timezone';
import { HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION } from '../../../Utils/Constants';
import PropTypes from 'prop-types';

import './ReactDatesChameleon.css';

class DateNav extends Component {
  static propTypes = {
    isPrev: PropTypes.bool,
    isMobile: PropTypes.bool
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const { isPrev = false, isMobile = false } = this.props;
    return isMobile ? this.getMobileNav(isPrev) : this.getDesktopNav(isPrev);
  }

  getDesktopNav = isPrev => {
    const iconDirection = isPrev ? 'togo-icon-rotate-90' : 'togo-icon-rotate-270';
    return <i className={`reactDatesChameleon togo-icon togo-icon-chevron ${iconDirection} navigationButtonsSize`} />;
  };

  getMobileNav = isPrev => {
    const { t } = this.context;
    const buttonText = isPrev ? t('buttons.previous') : t('buttons.next');
    const arrowDirection = isPrev ? 'togo-icon-arrow-left' : 'togo-icon-arrow-right';

    return (
      <div>
        <p className="reactDatesChameleon navigationTextMobile">{buttonText}</p>
        <i
          className={`reactDatesChameleon togo-icon ${arrowDirection} togo-icon-rotate-90 navigationButtonsSize navigationButtonsMobile`}
        />
      </div>
    );
  };
}

export function getReactDatesDefaults(isMobile) {
  const defaultProps = {
    hideKeyboardShortcutsPanel: true,
    weekDayFormat: 'dd',
    isOutsideRange: day =>
      day.isAfter(moment().endOf('day')) ||
      day.isBefore(
        moment()
          .subtract(2, 'year')
          .endOf('day')
      ),
    noBorder: true
  };

  if (isMobile) {
    return {
      ...defaultProps,
      orientation: VERTICAL_ORIENTATION,
      numberOfMonths: 12,
      navPrev: <DateNav isPrev={true} isMobile={true} />,
      navNext: <DateNav isMobile={true} />
    };
  }
  return {
    ...defaultProps,
    withPortal: true,
    orientation: HORIZONTAL_ORIENTATION,
    numberOfMonths: 2,
    navPrev: <DateNav isPrev={true} />,
    navNext: <DateNav />
  };
}



// WEBPACK FOOTER //
// ./src/Scss/Custom/ReactDates/ReactDatesChameleon.js